import { Util } from './_util.js';
import gatewayDefault from './gateway.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import Swiper from 'swiper/bundle';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

const App = {
  checkTouchDevice: function () {
    if ('ontouchstart' in document.documentElement) {
      $('body').addClass('touch-device');
    }
  },

  controlAnimation: function () {
    $(window)
      .on('resize', function () {
        $('body').addClass('no-animation');
        setTimeout(function () {
          $('.no-animation').removeClass('no-animation');
        }, 200);
      })
      .resize();
  },

  initGateway: function () {
    //<![CDATA[
    window.fpglobals = {
      cookeDomain: 'localhost',
    };

    window.fpglobals.gateway = new pine_ridge_Gateway({
      cookie: 'localhost-visited',
    });

    fpglobals.gateway.init();
    //]]>
  },

  hideAgeGate: function () {
    $(document).ready(function () {
      if (!$('.age-gate-module').is(':visible')) {
        $('html').removeClass('hidden');
      }
    });
  },

  getCopyrightYear: function () {
    const currentTime = new Date(),
      currentYear = currentTime.getFullYear();
    $('.footer .year').html(currentYear);
  },

  controlMainMenu: function () {
    function openMainMenu() {
      $('.header').addClass('header--open');
      $('.main-menu').scrollTop(0);
      $('.main-menu__toggle-btn').addClass('main-menu__toggle-btn--close');
      $('html').addClass('hidden');
    }

    function closeMainMenu() {
      $('.header').removeClass('header--open');
      $('.main-menu__toggle-btn').removeClass('main-menu__toggle-btn--close');
      $('html').removeClass('hidden');
    }

    $('.main-menu__toggle-btn').on('click', function () {
      if ($(this).hasClass('main-menu__toggle-btn--close')) {
        closeMainMenu();
      } else {
        openMainMenu();
      }
    });
  },

  init: function () {
    window.vin65remote.cart.init('https://shop.pineridgevineyards.com/', 0);
    window.vin65remote.product.addToCartForm('https://shop.pineridgevineyards.com/');
    window.vin65remote.usertools.loginWidget('https://shop.pineridgevineyards.com/');

    // Initialize Tock link handling
    this.handleTockLinks();
    this.debugTockLinks();


    // if ($('.js-WDMailingForm')[0]) {
    //   window.vin65remote.form.form('https://shop.pineridgevineyards.com/', 'Join our Mailing List');

    //   $('.js-WDMailingForm').on('click', function() {
    //     App.waitForFormLoad('.js-WDMailingForm', App.loadGoogleRecaptcha);
    //   });
    // }
    // if ($('.js-WDContactForm')[0]) {
    //   window.vin65remote.form.form('https://shop.pineridgevineyards.com/', 'Contact Us');
    //   App.waitForFormLoad('.js-WDContactForm', App.loadGoogleRecaptcha);
    // }

    // this.checkTouchDevice();
    // this.controlAnimation();
    // this.initGateway();
    // this.hideAgeGate();
    // this.controlMainMenu();
    // this.getCopyrightYear();
    // this.initGSAP();
    // this.initSwipers();
  },
  // Function to wait until the form is fully loaded before applying additional scripts like Google reCAPTCHA
  waitForFormLoad: function (selector, callback) {
    const interval = setInterval(() => {
      if (document.querySelector(selector + ' form')) {
        clearInterval(interval);
        callback(); // Execute the callback once form is ready
      }
    }, 100); // Check every 100ms
  },

  // Load Google reCAPTCHA script
  loadGoogleRecaptcha: function () {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  },

  handleTockLinks: function () {
    // Create a style element to override Tock's fixed positioning
    const styleOverride = document.createElement('style');
    styleOverride.textContent = `
      body.tock-prevent-fixed {
        position: static !important;
        overflow: auto !important;
      }
      #smooth-wrapper.tock-prevent-fixed {
        position: absolute !important;
        overflow: visible !important;
        transform: none !important;
      }
      #smooth-content.tock-prevent-fixed {
        transform: none !important;
      }
      #TockWidget {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
        max-height: 90vh;
        overflow: auto;
      }
    `;
    document.head.appendChild(styleOverride);

    // Track scroll position through ScrollSmoother
    let lastScrollPosition = 0;
    const smoothWrapper = document.getElementById('smooth-wrapper');
    const smoothContent = document.getElementById('smooth-content');

    if (smoothWrapper && smoothContent) {
      // Extract current transform Y value
      const getScrollPosition = () => {
        const transform = window.getComputedStyle(smoothContent).transform;
        const matrix = new DOMMatrix(transform);
        return Math.abs(matrix.m42); // Get Y transform value
      };

      // Update position on scroll
      const observer = new MutationObserver(() => {
        lastScrollPosition = getScrollPosition();
      });

      observer.observe(smoothContent, {
        attributes: true,
        attributeFilter: ['style'],
      });
    }

    document.addEventListener('click', (e) => {
      const tockLink = e.target.closest('[data-tock-reserve]');
      if (!tockLink) return;

      e.preventDefault();

      // Store current scroll position
      const scrollPosition = lastScrollPosition;
      console.log('Click at position:', scrollPosition);

      // Add our classes
      document.body.classList.add('tock-prevent-fixed');
      smoothWrapper?.classList.add('tock-prevent-fixed');
      smoothContent?.classList.add('tock-prevent-fixed');

      // Set the content position explicitly
      if (smoothContent) {
        smoothContent.style.transform = `matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, ${-scrollPosition}, 0, 1)`;
      }

      // Let Tock initialize
      if (window._tock) {
        window._tock(tockLink.dataset.tockExperience);
      }

      // Watch for widget close
      const widgetObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            const tockWidget = document.getElementById('TockWidget');
            if (tockWidget && tockWidget.style.display === 'none') {
              // Remove our classes
              document.body.classList.remove('tock-prevent-fixed');
              smoothWrapper?.classList.remove('tock-prevent-fixed');
              smoothContent?.classList.remove('tock-prevent-fixed');

              // Let ScrollSmoother take over again
              smoothContent.style.transform = '';
              widgetObserver.disconnect();
            }
          }
        });
      });

      // Watch the widget
      const tockWidget = document.getElementById('TockWidget');
      if (tockWidget) {
        widgetObserver.observe(tockWidget, {
          attributes: true,
          attributeFilter: ['style'],
        });
      }

      // Cleanup after 5 seconds if something goes wrong
      setTimeout(() => {
        document.body.classList.remove('tock-prevent-fixed');
        smoothWrapper?.classList.remove('tock-prevent-fixed');
        smoothContent?.classList.remove('tock-prevent-fixed');
        smoothContent.style.transform = '';
        widgetObserver.disconnect();
      }, 5000);
    });
  },

  debugTockLinks: function () {
    document.addEventListener('click', (e) => {
      const tockLink = e.target.closest('[data-tock-reserve]');
      if (!tockLink) return;

      const actualPosition = e.pageY - e.clientY;

      console.log('Tock link clicked:', {
        experienceId: tockLink.dataset.tockExperience,
        scrollPosition: actualPosition,
        eventDetails: {
          pageY: e.pageY,
          clientY: e.clientY,
          offsetY: e.offsetY,
          screenY: e.screenY,
        },
        href: tockLink.getAttribute('href'),
      });
    });
  },
};

export default App;
